import { API_BASE_URL } from "@/config";
import { BaseService } from "@/services/base-service";
import { mapMyHardwareSnapshot, MyHardwareWireResponse } from "./my-hardware.mapper";
import type { MyHardwareService, MyHardwareSnapshot } from "./my-hardware.types";

const MY_HARDWARE_STATUS_PATH = "/hss/status?parts=assets,lcrEligibility";

interface StatusResponse {
  myStatus?: MyHardwareWireResponse;
}

export class HttpMyHardwareService extends BaseService implements MyHardwareService {
  constructor() {
    super(API_BASE_URL);
  }

  public async getMyHardware(): Promise<MyHardwareSnapshot> {
    const response = await this.fetch(MY_HARDWARE_STATUS_PATH);
    if (!response.ok) throw new Error(`HSS API error: ${response.status}`);
    const body = (await response.json()) as StatusResponse;
    if (!body.myStatus) throw new Error("HSS status response is missing myStatus");
    return mapMyHardwareSnapshot(body.myStatus);
  }
}
